import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from 'antd';
import { IRoute } from 'interfaces';
import { v4 as uuidv4 } from 'uuid';
import './AppContent.scss';

interface AppContentProps {
  filteredRoutes: IRoute[];
}

const { Content } = Layout;

const AppContent: React.FC<AppContentProps> = props => {
  const { filteredRoutes } = props;

  return (
    <div className="main-app-container">
      <Content className="main-app-content">
        <Suspense fallback={null}>
          <Routes>
            {filteredRoutes.map(({ component: Component, ...rest }) => {
              return <Route {...rest} key={uuidv4()} element={<Component />} />;
            })}
            <Route path="/" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
      </Content>
    </div>
  );
};

export default AppContent;
